module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.ceb1127.ttf";